export default __webpack_public_path__ + "static/media/default-flag-16px.e4f9890c.svg";